import React from 'react';

import PageLayout from '../../components/PageLayout';
import ContentBlock from '../../components/ContentBlock';
import LetsWorkTogether from '../../components/LetsWorkTogether';
import Spacer from '../../components/Spacer';
import Row from '../../components/Row';
import Background from './images/header-services-bg.png';

const ServicesPage = () => (
  <PageLayout
    title="Services"
    header="Services"
    intro="We help startups in early stages to take off and support them along their project life cycle."
    visual={Background}
  >
    <Row>
      <ContentBlock
        image={require('./images/ilus-services-digital-product.svg')}
        imagePosition="left"
      >
        <div className="large-number">01</div>
        <h2>User Experience Design</h2>
        <p>
          When creating a digital product or service we tend to use the
          necessary methodologies, with an user centric approach to create the
          best customer experience.
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-datadriven.svg')}
        imagePosition="right"
      >
        <div className="large-number">02</div>
        <h2>Data-Driven Design</h2>
        <p>
          Design backed by data and helps users understand the target audience,
          this will prove the product and/or service is on the right track.
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-designsystem.svg')}
        imagePosition="left"
      >
        <div className="large-number">03</div>
        <h2>Design Systems</h2>
        <p>
          Creating visual guidelines that ensure consistency across a product
          and/or service’s interface. As features and teams grow, so does theiur
          design system, and makes it a critical component for a company’s
          scalability.
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-prototyping.svg')}
        imagePosition="right"
      >
        <div className="large-number">04</div>
        <h2>Prototyping</h2>
        <p>
          Helping navigate any and all facets of the digital landscape,
          assisting with wire-framing and interactive prototyping, creating
          experiences that deliver tangible business results.
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-interaction-design.svg')}
        imagePosition="left"
      >
        <div className="large-number">05</div>
        <h2>Interaction Design</h2>
        <p>
          Leading the way in interface design for mobile and web applications
          that are intuitive and visually appealing, putting consumers first.
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-brand-identity.svg')}
        imagePosition="right"
      >
        <div className="large-number">06</div>
        <h2>Brand Identity</h2>
        <p>
          Branding is a key aspect for any startup, organization or company.
          Having an effective brand strategy will give you a major advantage
          compared to your competitors
        </p>
      </ContentBlock>
      <Spacer height="90" />

      <ContentBlock
        image={require('./images/ilus-services-spint-facilitators.svg')}
        imagePosition="left"
      >
        <div className="large-number">07</div>
        <h2>Sprint Facilitators</h2>
        <p>
          A design sprint can help your company face a specific problem. Quickly
          test different approaches for your processes.
        </p>
      </ContentBlock>
      <Spacer height="90" />
    </Row>

    <LetsWorkTogether />
  </PageLayout>
);

export default ServicesPage;
